/* unplugin-vue-components disabled */import { render } from "./share.vue?vue&type=template&id=24a035ca"
import script from "./share.vue?vue&type=script&lang=js"
export * from "./share.vue?vue&type=script&lang=js"

import exportComponent from "D:\\云盘\\SynologyDrive\\Synology Drive\\文件\\客户调查表\\customweb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__